import { dropBoolean, dropOrgDest } from 'utils/drops';

const getCfoFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'cfo', label: 'CFOP', type: 'number', initial: true },
  {
    name: 'orgdest',
    label: 'Origem / Destino',
    type: 'select',
    options: dropOrgDest,
    multiple: true,
  },
  { name: 'descricao', label: 'Descrição' },
  { name: 'orientacao', label: 'Orientação' },
  { name: 'servico', label: 'Serviço', type: 'select', options: dropBoolean },
  {
    name: 'planoconta',
    label: 'Plano de Contas',
    type: 'select',
    options: drops?.Planoconta?.filter((p) => p?.operacional === 'SIM'),
    multiple: true,
  },
];

export default getCfoFilterFields;
